import React from 'react';

import Dashboard from './components/Dashboard/Dashboard';
import EmployeesTable from './components/EmployeesTable';

import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import useDocumentTitle from 'Shared/hooks/useDocumentTitle';
import getIdIfExist from 'Shared/util/getIdIfExist';
import useQueryParamsFilter from 'Shared/hooks/useQueryParamsFilter';

function EmployeesTab() {
  useDocumentTitle('Employees - List');

  const filterQueryParams = (query) => {
    if ('isActive' in query && query.isActive) delete query.isActive;
    if (query.project) query.project = getIdIfExist(query.project);
    if (query.position) query.position = getIdIfExist(query.position);

    return query;
  };

  const initialFilter = {
    term: '',
    isActive: true,
    project: null,
    position: null,
  };

  const [employeesFilter, setEmployeesFilter, meta] = useQueryParamsFilter(initialFilter, {
    filter: filterQueryParams,
  });

  const handleChange = (data) => {
    setEmployeesFilter((employeesFilter) => ({
      ...employeesFilter,
      ...data,
    }));
  };

  return (
    <div className="employees-tab" data-testid="employees-tab">
      <Dashboard
        searchInputValue={employeesFilter.term}
        onlyActive={employeesFilter.isActive}
        onDashboardChange={handleChange}
      />
      <EmployeesTable
        employeesFilter={employeesFilter}
        filterMeta={meta}
        onFilterChange={handleChange}
      />
    </div>
  );
}

export default withErrorBoundary(EmployeesTab);
